import WebApp from '@twa-dev/sdk'

export function moneyRain() {
  if (WebApp.platform === 'ios' || WebApp.platform === 'android') {
    for (let i = 0; i < 2; i++) {
      setTimeout(() => {
        WebApp.HapticFeedback.impactOccurred('light')
      }, 50 * i)
    }
  }
}
